<template>
  <Card :title="$t('global.safe-harbor')" :icons="service.hasSafeHarbor ? removeSafeHarbor : null">
    <LoadingState v-if="isLoading()" :size="50" />
    <div v-else class="mt-2">
      <div v-if="service.hasSafeHarbor">
        <Btn variant="primaryOutline" @click="openMigrationHelp" class="mb-3">
          {{ $t("global.ready-to-migrate") }}
        </Btn>
        <div>
          {{ $t("global.need-development-help") }}
          <a href="#" @click="openDevelopmentHelp">
            {{ $t("global.contact-our-support-team") }}
          </a>
        </div>
      </div>
      <div v-else class="text-right">
        <Btn variant="primary" @click="openPurchase" class="mb-3">
          {{ $t("global.purchase") }}
        </Btn>
      </div>
    </div>
  </Card>
</template>

<script>
import Btn from "@/components/display/Btn";
import Card from "@/components/display/Card";
import { computed } from "@vue/composition-api";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import SafeHarborDevelopmentHelp from "@/components/smart/modals/SafeHarborDevelopmentHelp";
import SafeHarborMigrationHelp from "@/components/smart/modals/SafeHarborMigrationHelp";
import SafeHarborPurchase from "@/components/smart/modals/SafeHarborPurchase";
import SafeHarborRemove from "@/components/smart/modals/SafeHarborRemove";
import store from "@/store";

export default {
  name: "SafeHarbor",
  components: {
    Btn,
    Card,
    LoadingState,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {
    const isUpdating = computed(() => store.getters["safeHarbor/isUpdating"](props.service.id));

    const getButtons = () => {
      const disabledButtons = [
        new NavLink(root.$t("global.purchase"), null, openPurchase, false, "primary"),
      ];
      const enabledButtons = [
        new NavLink(root.$t("global.ready-to-migrate"), null, openMigrationHelp, false),
      ];
      return props.service.hasSafeHarbor ? enabledButtons : disabledButtons;
    };

    const isLoading = () => isUpdating.value;

    const openDevelopmentHelp = () =>
      store.dispatch("modals/open", {
        template: SafeHarborDevelopmentHelp,
        data: { resourceId: props.service.id, type: "shared" },
      });

    const openMigrationHelp = () =>
      store.dispatch("modals/open", {
        template: SafeHarborMigrationHelp,
        data: { resourceId: props.service.id, type: "shared" },
      });

    const openPurchase = () =>
      store.dispatch("modals/open", {
        template: SafeHarborPurchase,
        data: { service: props.service },
      });

    const openRemove = () =>
      store.dispatch("modals/open", {
        template: SafeHarborRemove,
        data: { service: props.service },
      });

    const removeSafeHarbor = [
      new NavLink(root.$t("global.remove"), "trash", openRemove, false, null, "epsilon"),
    ];

    return {
      getButtons,
      isLoading,
      openDevelopmentHelp,
      openMigrationHelp,
      openPurchase,
      removeSafeHarbor,
    };
  },
};
</script>
